export default __webpack_public_path__ + "static/media/miniLogo.f0799810.png";